import React from 'react';
import WorkItemsView from '../components/WorkItemsView';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArchive } from '@fortawesome/free-solid-svg-icons';
import PageContainer from '../components/PageContainer';

const ArchivePage: React.FC = () => {
    return (
        <PageContainer>
            <div className="space-y-8">
                <div>
                    <div className="flex items-center gap-3">
                        <div className="p-2.5 bg-theme-secondary border border-theme rounded-xl text-theme-muted">
                            <FontAwesomeIcon icon={faArchive} size="lg" />
                        </div>
                        <h1 className="text-3xl font-bold text-theme tracking-tight">Archive</h1>
                    </div>
                    <p className="text-theme-secondary mt-2 ml-14">Reference for completed and archived items.</p>
                </div>

                <div className="w-full">
                    <WorkItemsView
                        initialView="all"
                        showHeader={false}
                        forcedState="ARCHIVED"
                    />
                </div>
            </div>
        </PageContainer>
    );
};

export default ArchivePage;
